export default class DtoReferencialInt {
    constructor(obj = {}) {
        this.code = obj.code
        this.name = obj.name
    }
}
